export default "__VITE_ASSET__CKU1JqEN__"